import { render, staticRenderFns } from "./WorkFlowCategoryEdit.vue?vue&type=template&id=3078d312&"
import script from "./WorkFlowCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./WorkFlowCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports